// ABOUTME: On a Nylas-booked coaching session's page: buttons to move or cancel it in-app
// ABOUTME: Shown only for the links the server sends; FreeBusy sessions use FreebusyAction instead
import { just, nothing } from 'maybeasy';
import { observer } from 'mobx-react';
import * as React from 'react';
import { EventResource } from '../../../EventsStore/Types';
import { findLink } from '../../../LinkyLinky';
import { T } from '../../../Translations';
import CancelCoachingSession from '../../CoachingScheduler/CancelCoachingSession';
import RescheduleSession from '../../CoachingScheduler/RescheduleSession';
import * as style from '../style.module.css';

interface Props {
  eventResource: EventResource;
}

const SessionChangeAction: React.FC<Props> = ({ eventResource }) => {
  const rescheduleLink = findLink('reschedule-session')(eventResource.links);
  const cancel = findLink('cancel-session')(eventResource.links).andThen((link) =>
    just({
      link,
      session: { startAt: eventResource.payload.startAt, endAt: eventResource.payload.endAt },
    }),
  );

  return (
    <RescheduleSession rescheduleLink={rescheduleLink} refresh={nothing()}>
      {(reschedule) => (
        <CancelCoachingSession cancel={cancel} refresh={nothing()}>
          {(cancelSession) =>
            reschedule.isNothing() && cancelSession.isNothing() ? (
              <></>
            ) : (
              <div className={style.freebusyAction}>
                <div className={style.actionPending}>
                  <T kind="Need to make changes or cancel your session?" />
                </div>
                {reschedule
                  .map((open) => (
                    <button
                      key="reschedule"
                      type="button"
                      className={style.rescheduleButtonCallToAction}
                      onClick={open}
                      data-intercom-target="coaching-session-page-reschedule-button"
                    >
                      <T kind="Reschedule Session" />
                    </button>
                  ))
                  .getOrElse(() => (
                    <></>
                  ))}
                {cancelSession
                  .map((open) => (
                    <button
                      key="cancel"
                      type="button"
                      className={style.cancelButtonCallToAction}
                      onClick={open}
                      data-intercom-target="coaching-session-page-cancel-button"
                    >
                      <T kind="Cancel Session" />
                    </button>
                  ))
                  .getOrElse(() => (
                    <></>
                  ))}
              </div>
            )
          }
        </CancelCoachingSession>
      )}
    </RescheduleSession>
  );
};

export default observer(SessionChangeAction);
